export enum listTypes {
    DirectActivations = 'DirectActivations',
    DirectActivationsF = 'DirectActivationsF',
    FormSons = 'FormSons'
}
